/**
 * Turf Cutting Service
 * Pure polygon utility functions for turf management.
 */

import area from '@turf/area';
import { polygon as turfPolygon } from '@turf/helpers';
import type { GeoJSONPolygon } from '@signalvote/shared';

/**
 * Calculate the area of a polygon in square meters.
 */
export function calculatePolygonArea(polygon: GeoJSONPolygon): number {
  try {
    const feature = turfPolygon(polygon.coordinates);
    return area(feature);
  } catch {
    return 0;
  }
}

/**
 * Format area for display (converts to acres or sq miles as appropriate).
 */
export function formatArea(squareMeters: number): string {
  const acres = squareMeters / 4046.86; // 1 acre = 4046.86 sq meters

  if (acres < 1) {
    return `${Math.round(squareMeters)} sq m`;
  } else if (acres < 100) {
    return `${acres.toFixed(1)} acres`;
  } else {
    const sqMiles = acres / 640;
    return `${sqMiles.toFixed(2)} sq mi`;
  }
}
